import { useCallback } from 'react';
import { MSG_TYPE_CREATE_COMMENT_IN_CACHE, MSG_TYPE_DELETE_COMMENT_SUCCESS, MSG_TYPE_EMBEDDED_COMMENT, MSG_TYPE_REMOVE_EMBEDDED_COMMENT } from 'collaboration-sidebar/constants/IFrameMessageTypes';
import COMMENT_TYPES from 'collaboration-sidebar/constants/CommentTypes';
export default function useCommentIndicatorsSync({
  setModuleReply,
  removeModuleReply,
  incrementReplyCountBy
}) {
  const handleMessage = useCallback(({
    payload
  }) => {
    var _payload$comment;
    switch (payload.type) {
      case MSG_TYPE_EMBEDDED_COMMENT:
        setModuleReply(payload.moduleId, (_payload$comment = payload.comment) !== null && _payload$comment !== void 0 ? _payload$comment : null);
        break;
      case MSG_TYPE_REMOVE_EMBEDDED_COMMENT:
        {
          const broadcastPayload = payload.payload;
          removeModuleReply(broadcastPayload.moduleId);
          break;
        }
      case MSG_TYPE_DELETE_COMMENT_SUCCESS:
        {
          // incrementReplyCountBy should handle not decrementing below 0 if the deleted comment was top level
          incrementReplyCountBy(payload.parentCommentId, -1);
          break;
        }
      case MSG_TYPE_CREATE_COMMENT_IN_CACHE:
        {
          const comment = payload.payload.commentData;
          // Only increment the reply count if this comment is actually a reply
          // ie don't increment the count for a top level comment
          if (comment.type === COMMENT_TYPES.REPLY) {
            incrementReplyCountBy(comment.parentId, 1);
          }
          break;
        }
      default:
        break;
    }
  }, [setModuleReply, removeModuleReply, incrementReplyCountBy]);
  return {
    handleMessage
  };
}